export const siteConfig = {
  name: '51吃瓜App',
  tagline: '每日吃瓜黑料爆料追踪',
  description: '51吃瓜app下载聚合页，提供最新入口与官网导航。覆盖今日网红吃瓜黑料、明星爆料实时更新，整合在线观看和每日大赛热门资源，一站直达现场。',
  url: 'https://51chigua.com',
  foundedYear: '2020',
  contactEmail: 'contact@51chigua.com',
};

export const navLinks = [
  { label: '首页', href: '/' },
  { label: '明星爆料', href: '/category/star' },
  { label: '网红吃瓜', href: '/category/influencer' },
  { label: '社会热点', href: '/category/social' },
  { label: '每日大赛', href: '/category/competition' },
  { label: '关于我们', href: '/about' },
];

export const footerNavColumns = [
  {
    title: '热门分类',
    links: [
      { label: '明星爆料', href: '/category/star' },
      { label: '网红吃瓜', href: '/category/influencer' },
      { label: '社会热点', href: '/category/social' },
      { label: '每日大赛', href: '/category/competition' },
      { label: '51吃瓜视频', href: '/category/video' },
    ],
  },
  {
    title: '快速链接',
    links: [
      { label: '关于我们', href: '/about' },
      { label: 'App下载', href: '#download' },
      { label: '最新入口', href: '/' },
      { label: '用户协议', href: '/terms' },
      { label: '隐私政策', href: '/privacy' },
    ],
  },
];

export const socialLinks = [
  { label: '微博', icon: 'ri-weibo-line', href: '#' },
  { label: '微信公众号', icon: 'ri-wechat-line', href: '#' },
  { label: '抖音', icon: 'ri-tiktok-line', href: '#' },
];